import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_STUDENTS, UPDATE_STUDENT } from './constants';
import {
  loadStudentsSuccess,
  loadStudentsError,
  updateStydentSuccess,
  updateStydentError,
} from './actions';

import history from 'utils/history';
import requestWrapper from 'utils/requestWrapper';

export function* loadStudents() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the students
    const itemsList = yield requestWrapper('GET', `students/list`, '', currentUser.token);

    if (!itemsList) {
      yield put(loadStudentsSuccess(false));
    } else {
      const firstElem = itemsList.data[0];
      yield put(loadStudentsSuccess(itemsList, firstElem));
    }
  } catch (error) {
    yield put(loadStudentsError(error));
  }
}

export function* updateStydent(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { studentDetail } = action;

    let updatedStydent = false,
      isNew = !studentDetail.hasOwnProperty('_id');

    if (isNew) {
      updatedStydent = yield requestWrapper(
        'POST',
        'students/new/',
        studentDetail,
        currentUser.token,
      );
    } else {
      updatedStydent = yield requestWrapper(
        'PATCH',
        `students/`,
        studentDetail,
        currentUser.token,
      );
    }

    if (!updatedStydent) {
      yield put(updateStydentSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/etudiants/${updatedStydent._id}` });
      }
      yield put(updateStydentSuccess(updatedStydent));
    }
  } catch (err) {
    yield put(updateStydentError(true));
  }
}

// Individual exports for testing
export default function* studentsSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_STUDENTS, loadStudents);
  yield takeLatest(UPDATE_STUDENT, updateStydent);
}
